import { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const AdminUserPage = lazy(() => import("./admin-user/AdminUserPage"));
const AdminGroupPage = lazy(() => import("./admin-group/AdminGroupPage"));
const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));
const ClientesPage = lazy(() => import("./clientes/ClientesPage"));
const PlanosPage = lazy(() => import("./planos/PlanosPage"));
const PremiosPage = lazy(() => import("./premios/PremiosPage"));
const RelatorioPage = lazy(() => import('./relatorios/RelatorioPage'));

export default function HomePage() {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<Redirect exact from="/" to="/dashboard" />

				<Route path="/dashboard" component={DashboardPage} />
				<Route path="/admin-user" component={AdminUserPage} />
				<Route path="/admin-group" component={AdminGroupPage} />
				<Route path="/clientes" component={ClientesPage} />
				<Route path="/planos" component={PlanosPage} />
				<Route path="/premios" component={PremiosPage} />
				<Route path='/relatorio' component={RelatorioPage}/>

				<Redirect to="/error/error-v6" />
			</Switch>
		</Suspense>
	);
}
